<template>
    <carousel :per-page="1" :mouse-drag="true" :autoplay="true" :adjustableHeight="true" :loop="true" :autoplayTimeout="10000" paginationActiveColor="#CD5360">
        <slide>
            <p class="tit"><strong>{{$t("1. Share your files from Google Drive")}}</strong></p>
            <v-img src="/images/slide1.png"></v-img>
        </slide>
        <slide>
            <p class="tit"><strong>{{$t("2. Define the license")}}</strong></p>
            <v-img height="100%" src="/images/slide2.png"></v-img>
        </slide>
        <slide>
            <p class="tit"><strong>{{$t("3. Keep track of the license")}}</strong></p>
            <v-img src="/images/slide3.png"></v-img>
        </slide>
        <slide>
            <p class="tit"><strong>{{$t("4. View the file!")}}</strong></p>
            <v-img src="/images/slide4.png"></v-img>
        </slide>
        <slide>
            <p class="tit"><strong>{{$t("5. Register to manage all your files")}}</strong></p>
            <v-img src="/images/slide5.png"></v-img>
        </slide>
    </carousel>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    import { VImg } from 'vuetify/lib'

    export default {
        name: "HelpPanel",
        components: { Carousel, Slide, VImg },
        methods: {
        }
    }
</script>

<style scoped>
    .tit {
        padding:5px;
        background: #CD5360;
        color:white;
    }
</style>